import Button from '@/components/Buttons/Button';
import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import CustomTooltip from '@/components/ToolTip/CustomTooltip';
import avatarDefault from '@/images/agents/AvatarDefault.png';
import avatarStitch from '@/images/agents/AvatarStitch.png';
import FaceScanSquare from '@/images/FaceScanSquare.svg';
import GalleryNewAgent from '@/images/GalleryNewAgent.svg';
import { useAgentEditorStore } from '@/state/root';
import theme from '@/theme';
import styled from '@emotion/styled';
import { tooltipClasses } from '@mui/material/Tooltip';
import { observer } from 'mobx-react-lite';

const StyledDiv = styled.div`
    display: flex;
    gap: 8px;
`;

const StyledStitchButton = styled(Button)<{ selected?: boolean }>`
    height: auto;
    padding: 2px 8px;
    border: ${({ selected, theme }) => `1px solid ${selected ? theme.colors.secondary.main : theme.colors.black[300]}`};
    background-color: ${({ theme }) => theme.colors.white};
`;

const StitchButtonText = styled.span`
    font-size: 12px;
    color: ${({ theme }) => theme.colors.black.main};
`;

const StyledToolTip = styled(CustomTooltip)`
    & .${tooltipClasses.tooltip} {
        color: ${theme.colors.secondary.main};
        background-color: transparent;
    }
`;

const AvatarImage = styled.div<{ src?: string }>`
    background: url(${props => props.src}) no-repeat center;
    width: 250px;
    height: 400px;
    border-radius: 3.5px;
`;

interface Props {
    hideTooltip?: boolean;
}

export const StitchButtons = observer(({ hideTooltip }: Props) => {
    const { presenterIsStitch, setPresenterIsStitch } = useAgentEditorStore();

    return (
        <StyledDiv>
            <StyledToolTip title={<AvatarImage src={avatarDefault}></AvatarImage>} placement="left" disableHoverListener={!!hideTooltip}>
                <StyledStitchButton
                    color="info"
                    size="small"
                    onClick={() => setPresenterIsStitch(true)}
                    selected={presenterIsStitch}
                    startIcon={<MaskedIcon src={GalleryNewAgent} size="12px" />}>
                    <StitchButtonText>Original size</StitchButtonText>
                </StyledStitchButton>
            </StyledToolTip>

            <StyledToolTip title={<AvatarImage src={avatarStitch}></AvatarImage>} placement="right" disableHoverListener={!!hideTooltip}>
                <StyledStitchButton
                    color="info"
                    size="small"
                    onClick={() => setPresenterIsStitch(false)}
                    selected={!presenterIsStitch}
                    startIcon={<MaskedIcon src={FaceScanSquare} size="12px" />}>
                    <StitchButtonText>Close up</StitchButtonText>
                </StyledStitchButton>
            </StyledToolTip>
        </StyledDiv>
    );
});
